import { Component, OnInit } from '@angular/core';
import { VacancyPage } from '../vacancy/vacancy.page';
import { ModalController, NavController } from '@ionic/angular';
import colors from '../../../assets/mockdata/colors.json';
import { Router } from '@angular/router';

@Component({
  selector: 'app-vacancies',
  templateUrl: './vacancies.page.html',
  styleUrls: ['./vacancies.page.scss'],
})
export class VacanciesPage implements OnInit {

  colors = colors;
  vacancies = null;

  constructor(
    public modalCtrl:ModalController,
    public nav:NavController,
    private router:Router
  ) { }

  ngOnInit() {
    if(!this.vacancies){
      let props = JSON.parse(localStorage.getItem('propsVacs')!);
      this.vacancies = props.vacancies;
    }
  }

  async openVacancy(vacancy) {
    let cssClass = 'modalBottom modalContent vacancyModal';

    if (window.screen.width < 861) {
      cssClass = 'mobileModal'

        localStorage.setItem('propsVac', JSON.stringify({
          vacancy: vacancy
        }));

        this.router.navigate(['vacancy']);
        return;
    }

    const modal = await this.modalCtrl.create({
      componentProps: {
        vacancy: vacancy
      },
      component: VacancyPage,
      cssClass: cssClass
    });

    await modal.present();
  }

}
